import {saveEvolutionSignature, signatureErrorMessage} from "./evolution/signature";
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import {

    X,

    ChevronLeft,

    ChevronRight,

    Download,

    Trash2,

    Lock,

    Pencil

} from "lucide-react";
import { storage, db } from "./firebase";
import { requestVexaConfirm } from "./notifications/dialogService";

import {

    ref,


    uploadBytes,

    getDownloadURL,

    deleteObject

} from "firebase/storage";

import {
    doc,
    updateDoc,
    deleteDoc,
    serverTimestamp,
    arrayUnion
} from "./access/firestore";

export default function EvolutionCard({

    cita,

    clinicId,

    formatearFecha

}) {

    const signatureRef = useRef(null);

    const [firmaVacia, setFirmaVacia] = useState(true);
    const [guardandoFirma, setGuardandoFirma] = useState(false);
    const [mostrarPopupFirma, setMostrarPopupFirma] = useState(false);
    const [mostrarPopupError, setMostrarPopupError] = useState(false);
    const [mensajePopupFirma, setMensajePopupFirma] = useState("");
    const [subiendoFotos, setSubiendoFotos] = useState(false);
    const [fotoSeleccionada, setFotoSeleccionada] = useState(-1);
    const [
        mostrarEditor,
        setMostrarEditor
    ] = useState(false);
    const [
        editForm,
        setEditForm
    ] = useState({
        motivo: cita.motivo || "",
        tratamiento: cita.tratamiento || "",
        notas: cita.notas || ""
    });
    const estaFirmada =
    Boolean(
        cita?.firmaURL ||
        cita?.firmadaAt ||
        cita?.firmadaPor
    );
    const citaRef = doc(

        db,

        "clinics",

        clinicId,

        "citas",

        cita.id

    );

        async function subirFotografias(files){

            if(!files.length) return;

            try{

                setSubiendoFotos(true);

                for(const file of files){

                    const filePath =

                        `clinics/${clinicId}/evolution/${cita.id}/${Date.now()}-${file.name}`;

                    const storageRef = ref(

                        storage,

                        filePath

                    );

                    await uploadBytes(

                        storageRef,

                        file

                    );

                    const url = await getDownloadURL(storageRef);

                    await updateDoc(

                        citaRef,

                        {

                            imagenes:

                                arrayUnion({

                                    url,

                                    path:filePath,

                                    nombre:file.name,

                                    createdAt:new Date()

                                })

                        }

                    );

                }

            }

            finally{

                setSubiendoFotos(false);

            }

        }

        async function eliminarFotografia(index){

            if(cita.firmaURL){

                return;

            }

            const confirmar = await requestVexaConfirm(

                "¿Eliminar esta fotografía?"

            );

            if(!confirmar) return;

            try{

                const nuevasFotos =

                    [...(cita.imagenes || [])];

                const foto = nuevasFotos[index];

                nuevasFotos.splice(index,1);

                setFotoSeleccionada(-1);

                await updateDoc(

                    citaRef,

                    {

                        imagenes:nuevasFotos

                    }

                );

                try{

                    if(foto.path){

                        await deleteObject(

                            ref(

                                storage,

                                foto.path

                            )

                        );

                    }

                }

                catch(error){

                    console.error(error);

                }

            }

            catch(error){

                console.error(error);

                alert(error.message);

            }

        }
        async function eliminarNota(){

            if (estaFirmada) {

                return;

            }

            const confirmar =
                await requestVexaConfirm(
                    "¿Eliminar esta nota de evolución definitivamente?"
                );

            if (!confirmar) {

                return;

            }

            try {

                await deleteDoc(
                    citaRef
                );

            }

            catch(error){

                console.error(
                    "Error eliminando nota:",
                    error
                );

                alert(
                    "No fue posible eliminar la nota."
                );

            }

        }

        async function guardarEdicion(){

            if (estaFirmada) {

                return;

            }

            try {

                await updateDoc(

                    citaRef,

                    {

                        motivo:
                            editForm.motivo,

                        tratamiento:
                            editForm.tratamiento,

                        notas:
                            editForm.notas,

                        updatedAt:
                            serverTimestamp()

                    }

                );

                setMostrarEditor(false);

            }

            catch(error){

                console.error(
                    "Error actualizando nota:",
                    error
                );

                alert(
                    "No fue posible guardar los cambios."
                );

            }

        }
    
                return (
                                    <div
                                        style={{
                                            background: "#fff",
                                            border: "1px solid #dbe4f0",
                                            borderLeft: "6px solid #2563eb",
                                            borderRadius: 14,
                                            padding: 18,
                                            marginBottom: 18,
                                            boxShadow: "0 4px 12px rgba(0,0,0,.05)",
                                            width: "100%",
                                            maxWidth: "100%",
                                            minWidth: 0,
                                            boxSizing: "border-box"
                                        }}
                                    >
                                        <style>{`
                                            .evolution-consulta-layout > * {
                                                min-width: 0;
                                            }

                                            .evolution-consulta-layout button {
                                                max-width: 100%;
                                                box-sizing: border-box;
                                            }

                                            .evolution-consulta-datos > * {
                                                min-width: 0;
                                                overflow-wrap: anywhere;
                                            }

                                            @media (max-width: 600px) {
                                                .evolution-consulta-layout {
                                                    grid-template-columns: minmax(0, 1fr) !important;
                                                    gap: 16px !important;
                                                }

                                                .evolution-consulta-datos {
                                                    grid-template-columns: minmax(0, 1fr) !important;
                                                    gap: 5px !important;
                                                }

                                                .evolution-consulta-datos > strong {
                                                    margin-top: 8px;
                                                }

                                                .evolution-consulta-layout button {
                                                    min-height: 44px;
                                                }
                                            }
                                        `}</style>

                                    <div
                                        style={{
                                            fontSize:12,
                                            color:"#6b7280",
                                            fontWeight:700,
                                            letterSpacing:1,
                                            marginBottom:8
                                        }}
                                    >
                                        CONSULTA
                                    </div>

                                    <div
                                        className="evolution-consulta-layout"
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "minmax(0, 1fr) 260px",
                                            gap: 24,
                                            alignItems: "start",
                                            width: "100%",
                                            minWidth: 0
                                        }}
                                    >

                                        {/* ==========================
                                            COLUMNA IZQUIERDA
                                        ========================== */}

                                        <div>

                                            <div
                                                style={{
                                                    fontSize:18,
                                                    fontWeight:700
                                                }}
                                            >
                                                {formatearFecha(cita.fecha)}
                                            </div>

                                            <div
                                                style={{
                                                    color:"#6b7280",
                                                    marginBottom:12
                                                }}
                                            >
                                                {cita.hora}
                                            </div>

                                            <div
                                                style={{
                                                    display:"flex",
                                                    gap:10,
                                                    marginBottom:18,
                                                    flexWrap:"wrap"
                                                }}
                                            >

                                                {!estaFirmada && (

                                                    <>

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setMostrarEditor(true)
                                                            }
                                                            style={{
                                                                display:"flex",
                                                                alignItems:"center",
                                                                gap:7,
                                                                padding:"9px 14px",
                                                                border:"1px solid #cbd5e1",
                                                                borderRadius:10,
                                                                background:"#fff",
                                                                color:"#334155",
                                                                fontWeight:600,
                                                                cursor:"pointer"
                                                            }}
                                                        >

                                                            <Pencil size={16}/>

                                                                Editar

                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={eliminarNota}
                                                            style={{
                                                                display:"flex",
                                                                alignItems:"center",
                                                                gap:7,
                                                                padding:"9px 14px",
                                                                border:"none",
                                                                borderRadius:10,
                                                                background:"#fee2e2",
                                                                color:"#b91c1c",
                                                                fontWeight:600,
                                                                cursor:"pointer"
                                                            }}
                                                        >

                                                            <Trash2 size={16}/>

                                                            Eliminar

                                                        </button>

                                                    </>

                                                )}

                                                {estaFirmada && (

                                                    <div
                                                        style={{
                                                            display:"flex",
                                                            alignItems:"center",
                                                            gap:7,
                                                            padding:"9px 14px",
                                                            borderRadius:10,
                                                            background:"#f0fdf4",
                                                            color:"#15803d",
                                                            fontWeight:600,
                                                            fontSize:14
                                                        }}
                                                    >

                                                        <Lock size={16}/>

                                                        Nota firmada

                                                    </div>

                                                )}

                                            </div>

                                            <strong>Estado</strong>

                                            <div
                                                style={{
                                                    marginBottom:12
                                                }}
                                            >
                                                {cita.estado || "—"}
                                            </div>

                                            <strong>Doctor</strong>

                                            <div
                                                style={{
                                                    marginBottom:18
                                                }}
                                            >
                                                {cita.doctorNombre || "—"}
                                            </div>

                                            <div
                                                className="evolution-consulta-datos"
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "minmax(0, 180px) minmax(0, 1fr)",
                                                    columnGap: 12,
                                                    rowGap: 12,
                                                    minWidth: 0,
                                                    width: "100%"
                                                }}
                                            >

                                                <strong>
                                                    Motivo de consulta
                                                </strong>

                                                <div
                                                    style={{
                                                        marginBottom:16
                                                    }}
                                                >
                                                    {cita.motivo || "—"}
                                                </div>

                                                <strong>
                                                    Tratamiento realizado
                                                </strong>

                                                <div
                                                    style={{
                                                        marginBottom:16
                                                    }}
                                                >
                                                    {cita.tratamiento || "—"}
                                                </div>

                                                <strong>
                                                    Evolución
                                                </strong>

                                                <div
                                                    style={{
                                                        whiteSpace:"pre-wrap",
                                                        marginBottom:16
                                                    }}
                                                >
                                                    {cita.notas || "—"}
                                                </div>

                                                <strong>
                                                    Próxima cita
                                                </strong>

                                                <div
                                                    style={{
                                                        marginBottom:16
                                                    }}
                                                >
                                                    {cita.proximo || "—"}
                                                </div>

                                                <strong>
                                                    Presupuesto
                                                </strong>

                                                <div>
                                                    $
                                                    {Number(
                                                        cita.presupuesto || 0
                                                    ).toLocaleString("es-MX")}
                                                </div>

                                                <strong>
                                                    Pagado
                                                </strong>

                                                <div>
                                                    $
                                                    {Number(
                                                        cita.pagado || 0
                                                    ).toLocaleString("es-MX")}
                                                </div>

                                                <strong>
                                                    Saldo pendiente
                                                </strong>

                                                <div>
                                                    $
                                                    {Number(
                                                        cita.saldo || 0
                                                    ).toLocaleString("es-MX")}
                                                </div>

                                            </div>

                                            {/* ==========================
                                                    FOTOGRAFÍAS CLÍNICAS
                                                ========================== */}

                                                <div
                                                    style={{

                                                        marginTop:28,

                                                        paddingTop:22,

                                                        borderTop:"1px solid #e5e7eb"

                                                    }}
                                                >

                                                    <div

                                                        style={{

                                                            display:"flex",

                                                            justifyContent:"space-between",

                                                            alignItems:"center",

                                                            marginBottom:14

                                                        }}

                                                    >

                                                        <strong>

                                                            Fotografías clínicas

                                                        </strong>

                                                    </div>

                                                    <div
                                                        style={{
                                                            display:"flex",
                                                            flexWrap:"wrap",
                                                            gap:12,
                                                            marginTop:12
                                                        }}
                                                    >

                                                        {(cita.imagenes || []).map((img,index)=>(

                                                            <img

                                                                key={index}

                                                                src={img.url}

                                                                alt="Fotografía clínica"

                                                                onClick={()=>{

                                                                    setFotoSeleccionada(index);

                                                                }}

                                                                style={{

                                                                    width:96,

                                                                    height:96,

                                                                    objectFit:"cover",

                                                                    borderRadius:12,

                                                                    border:"1px solid #d1d5db",

                                                                    cursor:"pointer",

                                                                    transition:"all .2s ease"

                                                                }}

                                                                onMouseEnter={e=>{

                                                                    e.currentTarget.style.transform="scale(1.05)";

                                                                    e.currentTarget.style.boxShadow="0 10px 25px rgba(0,0,0,.18)";

                                                                }}

                                                                onMouseLeave={e=>{

                                                                    e.currentTarget.style.transform="scale(1)";

                                                                    e.currentTarget.style.boxShadow="none";

                                                                }}

                                                            />

                                                        ))}

                                                        {
                                                            cita.firmaURL

                                                            ?

                                                            <label

                                                                style={{

                                                                    width:96,

                                                                    height:96,

                                                                    borderRadius:14,

                                                                    border:"2px solid #d1d5db",

                                                                    background:"#f3f4f6",

                                                                    display:"flex",

                                                                    flexDirection:"column",

                                                                    justifyContent:"center",

                                                                    alignItems:"center",

                                                                    color:"#9ca3af",

                                                                    cursor:"not-allowed"

                                                                }}

                                                            >

                                                                <Lock size={28}/>

                                                                <div

                                                                    style={{

                                                                        marginTop:8,

                                                                        fontSize:11,

                                                                        textAlign:"center",

                                                                        fontWeight:600

                                                                    }}

                                                                >

                                                                    Firmada

                                                                </div>

                                                            </label>

                                                            :

                                                            <label

                                                                style={{

                                                                    width:96,

                                                                    height:96,

                                                                    borderRadius:14,

                                                                    border:"2px dashed #cbd5e1",

                                                                    display:"flex",

                                                                    flexDirection:"column",

                                                                    justifyContent:"center",

                                                                    alignItems:"center",

                                                                    cursor:"pointer",

                                                                    transition:"all .2s ease",

                                                                    background:"#f8fafc"

                                                                }}

                                                                onMouseEnter={e=>{

                                                                    e.currentTarget.style.borderColor="#2563eb";

                                                                    e.currentTarget.style.background="#eff6ff";

                                                                }}

                                                                onMouseLeave={e=>{

                                                                    e.currentTarget.style.borderColor="#cbd5e1";

                                                                    e.currentTarget.style.background="#f8fafc";

                                                                }}

                                                            >

                                                                <div

                                                                    style={{

                                                                        fontSize:34,

                                                                        color:"#2563eb",

                                                                        fontWeight:300,

                                                                        lineHeight:1

                                                                    }}

                                                                >

                                                                    +

                                                                </div>

                                                                <div

                                                                    style={{

                                                                        marginTop:8,

                                                                        fontSize:12,

                                                                        color:"#2563eb",

                                                                        fontWeight:600

                                                                    }}

                                                                >

                                                                    Agregar

                                                                </div>

                                                                <input

                                                                    type="file"

                                                                    multiple

                                                                    accept="image/*"

                                                                    style={{

                                                                        display:"none"

                                                                    }}

                                                                    onChange={e=>

                                                                        subirFotografias(

                                                                            Array.from(

                                                                                e.target.files

                                                                            )

                                                                        )

                                                                    }

                                                                />

                                                            </label>

                                                        }

                                                    </div>

                                                    {

                                                        subiendoFotos &&

                                                        <div

                                                            style={{

                                                                marginTop:12,

                                                                color:"#2563eb",

                                                                fontWeight:600

                                                            }}

                                                        >

                                                            Subiendo fotografías...

                                                        </div>

                                                    }

                                                </div>

                                        </div>

                                        {/* ==========================
                                            COLUMNA DERECHA
                                        ========================== */}

                                        <div
                                            style={{
                                                display:"flex",
                                                flexDirection:"column",
                                                alignItems:"center",
                                                gap:12
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontWeight:700,
                                                    color:"#374151"
                                                }}
                                            >
                                                Firma del paciente
                                            </div>

                                            {

                                                cita.firmaURL

                                                ?

                                                <div
                                                    style={{
                                                        textAlign: "center"
                                                    }}
                                                >

                                                    <img

                                                        src={cita.firmaURL}

                                                        alt="Firma"

                                                        style={{

                                                            width: "100%",

                                                            border: "1px solid #d1d5db",

                                                            borderRadius: 8

                                                        }}

                                                    />

                                                    <div
                                                        style={{

                                                            marginTop: 8,

                                                            fontSize: 13,

                                                            color: "#16a34a",

                                                            fontWeight: 600

                                                        }}
                                                    >

                                                        Consulta firmada

                                                    </div>

                                                </div>

                                                :

                                                <SignatureCanvas

                                                    ref={signatureRef}

                                                    penColor="black"

                                                    canvasProps={{

                                                        width: 350,

                                                        height: 150,

                                                        className: "signatureCanvas"

                                                    }}

                                                    onEnd={() => {

                                                        setFirmaVacia(false);

                                                    }}

                                                />

                                            }

                                            {

                                                !cita.firmaURL &&

                                                <button
                                                    disabled={firmaVacia || guardandoFirma}
                                                    onClick={async () => {
                                                        if (firmaVacia || guardandoFirma) return;

                                                        setGuardandoFirma(true);

                                                        try {
                                                            const firma = signatureRef.current
                                                                .getCanvas()
                                                                .toDataURL("image/png");

                                                            await saveEvolutionSignature(clinicId, cita, firma);

                                                            setMostrarPopupFirma(true);
                                                        } catch (error) {
                                                            console.error(error);
                                                            setMensajePopupFirma(
                                                                signatureErrorMessage(error)
                                                            );
                                                            setMostrarPopupError(true);
                                                        } finally {
                                                            setGuardandoFirma(false);
                                                        }
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px",
                                                        border: "none",
                                                        borderRadius: 8,
                                                        background:
                                                            firmaVacia || guardandoFirma
                                                                ? "#9ca3af"
                                                                : "#2563eb",
                                                        color: "#fff",
                                                        cursor:
                                                            firmaVacia || guardandoFirma
                                                                ? "not-allowed"
                                                                : "pointer",
                                                        opacity: guardandoFirma ? 0.8 : 1
                                                    }}
                                                >
                                                    {guardandoFirma ? "Guardando..." : "Guardar firma"}
                                                </button>

                                            }

                                            {

                                                !cita.firmaURL &&

                                                <button

                                                    onClick={() => {

                                                        signatureRef.current.clear();

                                                        setFirmaVacia(true);

                                                    }}

                                                    style={{

                                                        width:"100%",

                                                        padding:"10px",

                                                        border:"1px solid #d1d5db",

                                                        borderRadius:8,

                                                        background:"#fff",

                                                        cursor:"pointer",

                                                        marginBottom:10

                                                    }}

                                                >

                                                    Limpiar firma

                                                </button>

                                            }

                                        </div>

                                    </div>
                                    
                                    {
                                        mostrarEditor &&
                                        !estaFirmada && (

                                            <div
                                                style={{
                                                    position:"fixed",
                                                    inset:0,
                                                    zIndex:9999,
                                                    background:"rgba(15,23,42,.48)",
                                                    display:"flex",
                                                    alignItems:"center",
                                                    justifyContent:"center",
                                                    padding:24
                                                }}

                                                onClick={() =>
                                                    setMostrarEditor(false)
                                                }
                                            >

                                                <div
                                                    onClick={e =>
                                                        e.stopPropagation()
                                                    }
                                                    style={{
                                                        width:"min(680px, 100%)",
                                                        maxHeight:"90vh",
                                                        overflowY:"auto",
                                                        background:"#fff",
                                                        borderRadius:20,
                                                        boxShadow:
                                                            "0 24px 70px rgba(15,23,42,.28)"
                                                    }}
                                                >

                                                    {/* ENCABEZADO */}

                                                    <div
                                                        style={{
                                                            display:"flex",
                                                            alignItems:"center",
                                                            justifyContent:"space-between",
                                                            padding:"20px 24px",
                                                            borderBottom:
                                                                "1px solid #e5e7eb"
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                display:"flex",
                                                                alignItems:"center",
                                                                gap:12
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    width:42,
                                                                    height:42,
                                                                    borderRadius:12,
                                                                    background:"#eff6ff",
                                                                    display:"flex",
                                                                    alignItems:"center",
                                                                    justifyContent:"center"
                                                                }}
                                                            >

                                                                <Pencil
                                                                    size={20}
                                                                    color="#2563eb"
                                                                />

                                                            </div>

                                                            <div>

                                                                <div
                                                                    style={{
                                                                        fontSize:18,
                                                                        fontWeight:700,
                                                                        color:"#0f172a"
                                                                    }}
                                                                >
                                                                    Editar nota de evolución
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        marginTop:3,
                                                                        fontSize:13,
                                                                        color:"#64748b"
                                                                    }}
                                                                >
                                                                    Modifica la información de esta nota
                                                                </div>

                                                            </div>

                                                        </div>

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setMostrarEditor(false)
                                                            }
                                                            style={{
                                                                width:36,
                                                                height:36,
                                                                border:"none",
                                                                borderRadius:10,
                                                                background:"#f1f5f9",
                                                                color:"#475569",
                                                                display:"flex",
                                                                alignItems:"center",
                                                                justifyContent:"center",
                                                                cursor:"pointer"
                                                            }}
                                                            title="Cerrar"
                                                        >

                                                            <X size={19}/>

                                                        </button>

                                                    </div>


                                                    {/* CONTENIDO */}

                                                    <div
                                                        style={{
                                                            padding:24
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                display:"flex",
                                                                flexDirection:"column",
                                                                gap:16
                                                            }}
                                                        >

                                                            <div>

                                                                <label
                                                                    style={{
                                                                        display:"block",
                                                                        fontWeight:600,
                                                                        fontSize:14,
                                                                        color:"#334155",
                                                                        marginBottom:7
                                                                    }}
                                                                >
                                                                    Motivo de consulta
                                                                </label>

                                                                <input
                                                                    value={editForm.motivo}
                                                                    onChange={e =>
                                                                        setEditForm({
                                                                            ...editForm,
                                                                            motivo:e.target.value
                                                                        })
                                                                    }
                                                                    style={{
                                                                        width:"100%",
                                                                        boxSizing:"border-box",
                                                                        height:44,
                                                                        padding:"0 12px",
                                                                        border:
                                                                            "1px solid #cbd5e1",
                                                                        borderRadius:10,
                                                                        fontSize:14,
                                                                        outline:"none"
                                                                    }}
                                                                />

                                                            </div>


                                                            <div>

                                                                <label
                                                                    style={{
                                                                        display:"block",
                                                                        fontWeight:600,
                                                                        fontSize:14,
                                                                        color:"#334155",
                                                                        marginBottom:7
                                                                    }}
                                                                >
                                                                    Tratamiento realizado
                                                                </label>

                                                                <textarea
                                                                    value={editForm.tratamiento}
                                                                    onChange={e =>
                                                                        setEditForm({
                                                                            ...editForm,
                                                                            tratamiento:e.target.value
                                                                        })
                                                                    }
                                                                    rows={3}
                                                                    style={{
                                                                        width:"100%",
                                                                        boxSizing:"border-box",
                                                                        padding:12,
                                                                        border:
                                                                            "1px solid #cbd5e1",
                                                                        borderRadius:10,
                                                                        fontSize:14,
                                                                        resize:"vertical",
                                                                        outline:"none"
                                                                    }}
                                                                />

                                                            </div>


                                                            <div>

                                                                <label
                                                                    style={{
                                                                        display:"block",
                                                                        fontWeight:600,
                                                                        fontSize:14,
                                                                        color:"#334155",
                                                                        marginBottom:7
                                                                    }}
                                                                >
                                                                    Evolución
                                                                </label>

                                                                <textarea
                                                                    value={editForm.notas}
                                                                    onChange={e =>
                                                                        setEditForm({
                                                                            ...editForm,
                                                                            notas:e.target.value
                                                                        })
                                                                    }
                                                                    rows={5}
                                                                    style={{
                                                                        width:"100%",
                                                                        boxSizing:"border-box",
                                                                        padding:12,
                                                                        border:
                                                                            "1px solid #cbd5e1",
                                                                        borderRadius:10,
                                                                        fontSize:14,
                                                                        resize:"vertical",
                                                                        outline:"none"
                                                                    }}
                                                                />

                                                            </div>

                                                        </div>

                                                    </div>


                                                    {/* BOTONES */}

                                                    <div
                                                        style={{
                                                            display:"flex",
                                                            justifyContent:"flex-end",
                                                            gap:10,
                                                            padding:"16px 24px",
                                                            borderTop:
                                                                "1px solid #e5e7eb",
                                                            background:"#f8fafc",
                                                            borderRadius:
                                                                "0 0 20px 20px"
                                                        }}
                                                    >

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setMostrarEditor(false)
                                                            }
                                                            style={{
                                                                height:42,
                                                                padding:"0 16px",
                                                                border:
                                                                    "1px solid #cbd5e1",
                                                                borderRadius:10,
                                                                background:"#fff",
                                                                color:"#334155",
                                                                fontWeight:600,
                                                                cursor:"pointer"
                                                            }}
                                                        >
                                                            Cancelar
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={guardarEdicion}
                                                            style={{
                                                                height:42,
                                                                padding:"0 18px",
                                                                border:"none",
                                                                borderRadius:10,
                                                                background:"#2563eb",
                                                                color:"#fff",
                                                                fontWeight:700,
                                                                cursor:"pointer",
                                                                display:"flex",
                                                                alignItems:"center",
                                                                gap:8
                                                            }}
                                                        >

                                                            <Pencil size={16}/>

                                                            Guardar cambios

                                                        </button>

                                                    </div>

                                                </div>

                                            </div>

                                        )
                                    }

                                    {
                                        fotoSeleccionada >= 0 &&
                                        cita.imagenes?.[fotoSeleccionada] && (

                                            <div

                                                onClick={()=>{

                                                    setFotoSeleccionada(-1);

                                                }}

                                                style={{

                                                    position:"fixed",

                                                    inset:0,

                                                    background:"rgba(0,0,0,.88)",

                                                    display:"flex",

                                                    justifyContent:"center",

                                                    alignItems:"center",

                                                    zIndex:99999

                                                }}

                                            >

                                                {/* BOTÓN CERRAR */}

                                                <button

                                                    onClick={(e)=>{

                                                        e.stopPropagation();

                                                        setFotoSeleccionada(-1);

                                                    }}

                                                    style={{

                                                        position:"absolute",

                                                        top:24,

                                                        right:24,

                                                        width:48,

                                                        height:48,

                                                        border:"none",

                                                        borderRadius:"50%",

                                                        background:"rgba(255,255,255,.15)",

                                                        color:"#fff",

                                                        cursor:"pointer",

                                                        display:"flex",

                                                        justifyContent:"center",

                                                        alignItems:"center"

                                                    }}

                                                >

                                                    <X size={22}/>

                                                </button>

                                                {/* FLECHA IZQUIERDA */}

                                                {

                                                    fotoSeleccionada > 0 &&

                                                    <button

                                                        onClick={(e)=>{

                                                            e.stopPropagation();

                                                            setFotoSeleccionada(

                                                                fotoSeleccionada-1

                                                            );

                                                        }}

                                                        style={{

                                                            position:"absolute",

                                                            left:30,

                                                            border:"none",

                                                            background:"rgba(255,255,255,.15)",

                                                            color:"#fff",

                                                            width:52,

                                                            height:52,

                                                            borderRadius:"50%",

                                                            cursor:"pointer",

                                                            display:"flex",

                                                            justifyContent:"center",

                                                            alignItems:"center"

                                                        }}

                                                    >

                                                        <ChevronLeft size={28}/>

                                                    </button>

                                                }

                                                {/* FOTO */}

                                                <img

                                                    src={
                                                        cita.imagenes?.[fotoSeleccionada]?.url || ""
                                                    }

                                                    alt=""

                                                    onClick={e=>e.stopPropagation()}

                                                    style={{

                                                        maxWidth:"90vw",

                                                        maxHeight:"88vh",

                                                        borderRadius:18,

                                                        boxShadow:"0 30px 80px rgba(0,0,0,.45)"

                                                    }}

                                                />

                                                {/* FLECHA DERECHA */}

                                                {

                                                    fotoSeleccionada < cita.imagenes.length-1 &&

                                                    <button

                                                        onClick={(e)=>{

                                                            e.stopPropagation();

                                                            setFotoSeleccionada(

                                                                fotoSeleccionada+1

                                                            );

                                                        }}

                                                        style={{

                                                            position:"absolute",

                                                            right:30,

                                                            border:"none",

                                                            background:"rgba(255,255,255,.15)",

                                                            color:"#fff",

                                                            width:52,

                                                            height:52,

                                                            borderRadius:"50%",

                                                            cursor:"pointer",

                                                            display:"flex",

                                                            justifyContent:"center",

                                                            alignItems:"center"

                                                        }}

                                                    >

                                                        <ChevronRight size={28}/>

                                                    </button>

                                                }

                                                {/* CONTADOR */}

                                                <div

                                                    style={{

                                                        position:"absolute",

                                                        bottom:30,

                                                        color:"#fff",

                                                        fontWeight:600,

                                                        fontSize:16

                                                    }}

                                                >

                                                    {fotoSeleccionada+1}

                                                    {" / "}

                                                    {cita.imagenes.length}

                                                </div>

                                                {

                                                    cita.firmaURL

                                                    ?

                                                    <div

                                                        style={{

                                                            position:"absolute",

                                                            bottom:70,

                                                            display:"flex",

                                                            alignItems:"center",

                                                            gap:8,

                                                            color:"#fff",

                                                            background:"rgba(0,0,0,.45)",

                                                            padding:"10px 18px",

                                                            borderRadius:14,

                                                            fontWeight:600

                                                        }}

                                                    >

                                                        <Trash2

                                                            size={18}

                                                            opacity={0.45}

                                                        />

                                                        Consulta firmada

                                                    </div>

                                                    :

                                                    <button

                                                        onClick={(e)=>{

                                                            e.stopPropagation();

                                                            eliminarFotografia(

                                                                fotoSeleccionada

                                                            );

                                                        }}

                                                        style={{

                                                            position:"absolute",

                                                            bottom:70,

                                                            display:"flex",

                                                            alignItems:"center",

                                                            gap:8,

                                                            border:"none",

                                                            borderRadius:14,

                                                            padding:"12px 18px",

                                                            background:"#dc2626",

                                                            color:"#fff",

                                                            cursor:"pointer",

                                                            fontWeight:600,

                                                            transition:"all .2s ease"

                                                        }}

                                                        onMouseEnter={e=>{

                                                            e.currentTarget.style.background="#b91c1c";

                                                        }}

                                                        onMouseLeave={e=>{

                                                            e.currentTarget.style.background="#dc2626";

                                                        }}

                                                    >

                                                        <Trash2 size={18}/>

                                                        Eliminar fotografía

                                                    </button>

                                                }

                                            </div>

                                        )

                                    }

                               
                                    {(mostrarPopupFirma || mostrarPopupError) && (
                                        <div
                                            style={{
                                                position: "fixed",
                                                inset: 0,
                                                zIndex: 100000,
                                                background: "rgba(15, 23, 42, 0.45)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 20
                                            }}
                                        >
                                            <div
                                                role="dialog"
                                                aria-modal="true"
                                                style={{
                                                    width: "100%",
                                                    maxWidth: 380,
                                                    background: "#fff",
                                                    borderRadius: 16,
                                                    padding: 24,
                                                    textAlign: "center",
                                                    boxShadow: "0 20px 50px rgba(0,0,0,0.2)"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 48,
                                                        height: 48,
                                                        margin: "0 auto 14px",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        background: mostrarPopupError ? "#fee2e2" : "#dcfce7",
                                                        color: mostrarPopupError ? "#b91c1c" : "#15803d",
                                                        fontSize: 28,
                                                        fontWeight: 700
                                                    }}
                                                >
                                                    {mostrarPopupError ? "!" : "✓"}
                                                </div>

                                                <div style={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>
                                                    {mostrarPopupError
                                                        ? "No se pudo guardar la firma"
                                                        : "Firma guardada exitosamente"}
                                                </div>

                                                {mostrarPopupError && (
                                                    <p style={{ color: "#4b5563", fontSize: 14 }}>
                                                        {mensajePopupFirma}
                                                    </p>
                                                )}

                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setMostrarPopupFirma(false);
                                                        setMostrarPopupError(false);
                                                        setMensajePopupFirma("");
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        marginTop: 20,
                                                        padding: 11,
                                                        border: "none",
                                                        borderRadius: 8,
                                                        background: "#2563eb",
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    Aceptar
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
}
